import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import type { BeniSmartCompset, BeniSmartCompsetCategory } from 'lumen/models';
import type HotelSettingsCompetitorsBenchmarkRoute from 'lumen/routes/hotel/settings/competitors/benchmark';
import {
  BENI_SMART_COMPSET_CATEGORY_WEIGHT_TRANSLATIONS,
  type BeniSmartCompsetCategoryWithWeight,
} from 'lumen/utils/constants/benchmark-insight/beni-smart-compset-constant-values';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCompetitorsBenchmarkSmartCompsetWeightsController extends Controller {
  declare model: ModelFrom<HotelSettingsCompetitorsBenchmarkRoute>;

  @service declare intl: Services['intl'];
  @service declare router: Services['router'];

  get categories(): BeniSmartCompsetCategoryWithWeight[] {
    return (
      this.smartCompset?.categories.filter(
        (category): category is BeniSmartCompsetCategoryWithWeight =>
          category.weight !== null,
      ) ?? []
    );
  }

  get smartCompset(): BeniSmartCompset | null | undefined {
    return this.model.smartCompset.last?.value;
  }

  get tickLabels(): string[] {
    return [
      this.intl.t(BENI_SMART_COMPSET_CATEGORY_WEIGHT_TRANSLATIONS[1]),
      this.intl.t(BENI_SMART_COMPSET_CATEGORY_WEIGHT_TRANSLATIONS[3]),
      this.intl.t(BENI_SMART_COMPSET_CATEGORY_WEIGHT_TRANSLATIONS[5]),
    ];
  }

  @action
  onBack(): void {
    this.router.transitionTo(
      'hotel.settings.competitors.benchmark.smart-compset.categories',
    );
  }

  @action
  onCloseModal(): void {
    this.router.transitionTo('hotel.settings.competitors.benchmark');
  }

  @action
  onContinue(): void {
    this.router.transitionTo(
      'hotel.settings.competitors.benchmark.smart-compset.review',
    );
  }

  @action
  onInput(category: BeniSmartCompsetCategory, value: number): void {
    this.smartCompset?.updateWeight(category, value);
  }
}
